import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import api from "@/lib/api";
import { timeAgo } from "@/lib/format";
import PageHeader from "@/components/PageHeader";
import { Button } from "@/components/ui/button";
import { Bell, Droplets, Receipt, X } from "lucide-react";

const ICONS = { waiter: Bell, water: Droplets, bill: Receipt, cancel: X };
const LABEL = { waiter: "Waiter", water: "Water", bill: "Bill", cancel: "Cancel" };

export default function Calls() {
  const qc = useQueryClient();
  const { data: calls = [] } = useQuery({
    queryKey: ["calls"],
    queryFn: async () => (await api.get("/calls")).data,
    refetchInterval: 2500,
  });

  const ack = async (c) => {
    await api.post(`/calls/${c.id}/ack`);
    toast.success(`Table ${c.table_name} acknowledged`);
    qc.invalidateQueries({ queryKey: ["calls"] });
  };

  return (
    <div className="h-full overflow-y-auto p-6 lg:p-8" data-testid="calls-page">
      <PageHeader title="Waiter Calling" subtitle="Guest pager from Scan & Order — Waiter / Water / Bill / Cancel" />
      <div className="space-y-3 max-w-xl">
        {calls.map((c) => {
          const Icon = ICONS[c.type] || Bell;
          return (
            <div key={c.id} className="kul-card p-5 flex items-center gap-4" data-testid={`call-${c.id}`}>
              <div className="w-12 h-12 rounded-xl bg-[var(--kul-primary)]/10 text-[var(--kul-primary)] grid place-items-center">
                <Icon className="w-6 h-6" />
              </div>
              <div className="flex-1">
                <div className="font-display font-700 text-lg">Table {c.table_name}</div>
                <div className="text-sm text-neutral-500">{LABEL[c.type] || c.type} · {timeAgo(c.created_at)}</div>
              </div>
              <Button onClick={() => ack(c)} className="bg-[var(--kul-primary)] text-white">On my way</Button>
            </div>
          );
        })}
        {!calls.length && <div className="text-neutral-400 py-16 text-center">No open calls. Guests page from the table QR.</div>}
      </div>
    </div>
  );
}
